module.exports = __webpack_public_path__ + "media/images/photo-f78bdf1d9aee08032a2ff3bdb2230638.png";